export const splitStyleAndContent = (html: string): { styles: string; html: string } => {
  const styles: string[] = [];

  let match;
  while ((match = styleRegex.exec(html)) !== null) {
    styles.push(match[1]); // match[1] is the captured content inside style tags
  }

  const htmlContent = html.replace(styleRegex, "");
  return { styles: styles.join(" "), html: htmlContent };
};

const styleRegex = /<\s*style[^>]*\s*>([\s\S]*?)<\/\s*style\s*>/gi;

export const prependStyles = (styles: string, html: string) =>
  styles.trim() === "" ? html : `<style>${styles}</style>${html}`;
